import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const FbAgenticMessageSenderModal = React.lazy(
  () => import("./fb-agentic-message-sender.modal"),
);

const FbAgenticMessageSender: iModalProps<
  typeof FbAgenticMessageSenderModal,
  { conversationId: string }
> = {
  name: "fb-agentic-message-sender",
  component: GenerateModalWithSuspense(FbAgenticMessageSenderModal),
};

export default FbAgenticMessageSender;
